/// Store
import { clearElementState } from "component/toolManager/toolState.js";

/**
 *
 *
 * @param {number} viewportIndex
 * @param {*} data
 */
const requestDeleteToolState = (element: any) => {
  if (element === null || element === undefined) {
    return;
  }
  clearElementState(element);
};

export default requestDeleteToolState;
